(function ($, slickcarousel, youtubebackground) {

  $(document).ready(function () {
    sliderResizer('.single-collection__header');

    if ($('.section-slider__content').length > 0) {

      $('[data-vbg]').youtube_background();

      sliderResizer('.section-slider__content__item');

      $('.section-slider__content').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        arrows: true,
        prevArrow: '<span class="prev-arrow"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
        appendArrows: '.slider-nav__content',
        appendDots: '.slider-nav__content',
        nextArrow: '<span class="next-arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
        autoplaySpeed: 6000,
        fade: true,
        cssEase: 'linear'
      });
    }

    if ($('.background-video__slider').length > 0) {

      $('.background-video__slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        arrows: true,
        prevArrow: $('.slider-left'),
        nextArrow: $('.slider-right'),
        appendDots: '.slider-nav__content',
        autoplaySpeed: 6000,
        fade: true,
        cssEase: 'linear'
      });

      var numberOfSlide = $(this).find( '.slick-slide').length;
      if (numberOfSlide < 2){
        $(this).find('.slider-nav').hide();
      }
    }

    // Single Collection

    if ($('.single-collection__intended__slider').length > 0) {
      $('.single-collection__intended__slider').slick({
        infinite: true,
        // slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        dots: true,
        autoplay: true,
        arrows: true,
        prevArrow: '<span class="prev-arrow"><i class="icon-left-open" aria-hidden="true"></i></span>',
        appendArrows: '.slider-nav__content',
        appendDots: '.slider-nav__content',
        nextArrow: '<span class="next-arrow"><i class="icon-right-open" aria-hidden="true"></i></span>',
        autoplaySpeed: 6000,
        // fade: true,
        cssEase: 'linear'
      });

      var numberOfSlide = $(this).find( '.slick-slide').length;
      if (numberOfSlide < 2){
        $(this).find('.slider-nav').hide();
      }
    }
  });

  $(window).resize(function () {
    sliderResizer('.section-slider__content__item');
    sliderResizer('.single-collection__header');
  });

  function sliderResizer(ele) {

    if (ele.length > 0){
      var headerMenu = $('body').hasClass('home') ? 0 : $('.header-menu').outerHeight(true);
      var navBarHeight = $('#wpadminbar').length > 0 ? $('#wpadminbar').outerHeight(true) : 0;
      var breadcrumbs = $('.breadcrumb-custom').length > 0 ? $('.breadcrumb-custom').outerHeight(true) : 0;
      var sliderHeight = $(window).height() - headerMenu - navBarHeight - breadcrumbs;
      $(ele).height(sliderHeight);
    }
  }

})
(jQuery, SlickCarousel, YoutubeBackground);
